require('../fhApp/hostnameMatchService');

"use strict";

angular.module('app.shared.profileService', [
  'app.hostnameMatchService'
])
  .factory('app.shared.profileService', [
    'hostnameMatchService', '$state',
    function (hostnameMatch, $state) {
      return {
        buildProfileUrl: function (username) {
          return (hostnameMatch.base_url() + '/#/profiles/' + username);
        },
        gotoProfileState: function (username) {
          $state.go('app.userProfile.feed', {username: username});
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/profileService.js